module.exports = __webpack_public_path__ + "static/the-five-dysfunctions-of-a-team-77e9c9a1fadbb590a82ae966ee32b3d0.jpg";